module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title-general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tChange Password\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    staticClass: "modal__section",
    class: {
      'has-error': _vm.errors.any()
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword($event)
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "append-icon": _vm.showCurrentPassword ? 'visibility_off' : 'visibility',
      "label": "Current password",
      "data-vv-validate-on": "blur",
      "type": _vm.showCurrentPassword ? 'text' : 'password',
      "name": "curpassword",
      "error-messages": _vm.errors.has('curpassword') ? 'Enter current password' : [],
      "outlined": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showCurrentPassword = !_vm.showCurrentPassword
      }
    },
    model: {
      value: (_vm.credential.currentPassword),
      callback: function($$v) {
        _vm.$set(_vm.credential, "currentPassword", $$v)
      },
      expression: "credential.currentPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    attrs: {
      "append-icon": _vm.showPassword ? 'visibility_off' : 'visibility',
      "label": "New password",
      "data-vv-validate-on": "blur",
      "type": _vm.showPassword ? 'text' : 'password',
      "name": "password",
      "error-messages": _vm.errors.has('password') ? 'Add new password' : [],
      "outlined": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.newPasswordUnused),
      callback: function($$v) {
        _vm.newPasswordUnused = $$v
      },
      expression: "newPasswordUnused"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "label": "Retype new password",
      "data-vv-validate-on": "blur",
      "type": "password",
      "name": "repassword",
      "error-messages": _vm.touched && _vm.errors.has('repassword') ? 'New passwords don\'t match' : [],
      "outlined": ""
    },
    model: {
      value: (_vm.credential.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.credential, "newPassword", $$v)
      },
      expression: "credential.newPassword"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "submit",
      "loading": _vm.isSaving,
      "disabled": _vm.isSaving,
      "color": "primary"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave settings\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('apierror')),
      expression: "errors.has('apierror')"
    }],
    staticClass: "input-field__error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apierror')) + " ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6560073f","hasScoped":false}!./app/components/account-password-modal/template.html
// module id = 359
// module chunks = 0